module.exports = __webpack_public_path__ + "img/31.4894333c.gif";